// Task 6 — list hook for /admin/teams (useQueueInstructions pattern).
import { useCallback, useEffect, useState } from "react";
import { teamsApi, type TeamRecord } from "../api/client";

export function useTeams() {
  const [teams, setTeams] = useState<TeamRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const result = await teamsApi.list();
      setTeams(result.teams);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { teams, loading, error, refetch };
}
